import script from "./documentMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./documentMessage.vue?vue&type=script&setup=true&lang=ts"

import "./documentMessage.vue?vue&type=style&index=0&id=a99c95be&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a99c95be"]])

export default __exports__